export default "/images/confex.png?2542e4a9a3b6d0c9875237179884fe65";